/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
};

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class UnarchiveAccountSuccess extends React.Component<*> {
  componentDidMount() {
    this.props.accountStore.details.details.archived_at = null; // eslint-disable-line camelcase
    this.props.accountStore.details.details.is_enabled = false; // eslint-disable-line camelcase
  }

  render(): React.Node {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const { currentAccountDetails, t }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:trading_accounts.unarchive')}</h3>
            <p>{t('general:trading_accounts.messages.unarchived')}</p>
          </div>
          <div className={styles['archive-account-details']}>
            <React.Fragment>
              <b>{t('general:trading_account')}:</b>
              <ul>
                {<li>{actionDrawerStore.response.name}</li>}
                {<li>{actionDrawerStore.response.account_no}</li>}
              </ul>
            </React.Fragment>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
